type Listener = () => void;

class SimpleEventEmitter {
  private _listeners = new Map<string, Set<Listener>>();

  on(event: string, listener: Listener): this {
    if (!this._listeners.has(event)) this._listeners.set(event, new Set());
    this._listeners.get(event)!.add(listener);
    return this;
  }

  off(event: string, listener: Listener): this {
    this._listeners.get(event)?.delete(listener);
    return this;
  }

  emit(event: string): void {
    this._listeners.get(event)?.forEach((fn) => fn());
  }
}

export const toolTipEventBus = new SimpleEventEmitter();
